import { Chip } from '@mui/material';

export default function getStatusChip(params) {
  switch (params.value) {
    case 'A':
      return (
        <Chip
          label={'Added'}
          size="small"
          variant="outlined"
          sx={{ color: 'green', borderColor: 'green' }}
          data-cy="status-chip"
        />
      );
    case 'D':
      return (
        <Chip
          label={'Deleted'}
          size="small"
          variant="outlined"
          sx={{ color: 'red', borderColor: 'red' }}
          data-cy="status-chip"
        />
      );
    case 'C':
      return (
        <Chip
          label={'Changed'}
          size="small"
          variant="outlined"
          sx={{ color: 'orange', borderColor: 'orange' }}
          data-cy="status-chip"
        />
      );
    case 'O':
      return <Chip label={'Current'} size="small" variant="outlined" data-cy="status-chip" />;
  }
}
